import React, { useState } from "react";
import Header from "@features/ux/components/Header";
import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import IndividualMessage from "./IndividualMessage";
import BulkMessage from "./BulkMessage";
import { useNavigate } from "react-router-dom";

function MessagingLanding() {
  const navigate = useNavigate();
  const tabComponents = {
    individual: {
      label: "Individual",
      shortLabel: "Individual",
      component: <IndividualMessage />,
    },
    bulk: {
      label: "Bulk",
      shortLabel: "Bulk",
      component: <BulkMessage />,
    },
  };

  const urlMapping = {
    individual: "individual",
    bulk: "bulk",
  };

  const handleViewHistory = () => {
    // Navigate to the scheduled messages history page
    navigate("/communication-hub/scheduled-messages");
  };
  return (
    <div className="w-full px-4 space-y-6">
      <div className="flex justify-between items-center">
        <Header
          title="Messaging"
          subtext="Send messages to individual or multiple recipients across various communication channels."
        />
        <Button onClick={handleViewHistory}>Scheduled Messages</Button>
      </div>

      <Tabs
        defaultValue="individual"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid grid-cols-2 gap-2"
        className="space-y-4"
      />
    </div>
  );
}

export default MessagingLanding;
